export const  buildFormModel = (form) => {
    return {idFormulario : form[0], idPlanilha : form[1], link : form[2], drive : form[3] }

}